import { Checkbox, Group, MantineColor, Stack, Text } from '@mantine/core'
import { useHover } from '@mantine/hooks'
import { ReactNode } from 'react'

type CheckboxCardProps = {
  checked: boolean
  title: ReactNode
  description: ReactNode
  defaultBg?: MantineColor
  onClick: () => void
}

export const CheckboxCard = ({
  checked,
  title,
  description,
  defaultBg,
  onClick
}: CheckboxCardProps) => {
  const { hovered, ref } = useHover()

  return (
    <Checkbox.Card
      ref={ref}
      radius="md"
      checked={checked}
      styles={(theme) => ({
        card: {
          padding: theme.spacing.md,
          borderColor: checked
            ? theme.colors[theme.primaryColor][6]
            : theme.colors.gray[4],
          background: hovered ? theme.colors.gray[0] : defaultBg
        }
      })}
      onClick={onClick}
    >
      <Group wrap="nowrap" align="flex-start">
        <Checkbox.Indicator />

        <Stack gap={4}>
          <Text size="sm" fw={500} lh={1.3}>
            {title}
          </Text>

          <Text size="xs" c="dimmed">
            {description}
          </Text>
        </Stack>
      </Group>
    </Checkbox.Card>
  )
}
